import React from 'react';
import { useSelector } from 'react-redux';
import { Flex, ProgressCircle } from '@adobe/react-spectrum';
import { ContentView } from 'app/views/components/Content';
import { BusyDialog } from 'app/views/components/dialogs/BusyDialog';
import { ClipboardDialog } from 'app/views/components/dialogs/Clipboard';
import { NewsDialog } from 'app/views/components/dialogs/News';
import { Prompt } from 'app/views/components/dialogs/Prompt';
import { RejectionsDialog } from 'app/views/components/dialogs/RejectionsDialogs';
import { HeaderView } from 'app/views/components/Header';
import { Text } from 'app/views/components/typography/Text';
const WrapperStyles = { overflow: 'hidden' };
const LoadingConfigView = () => (React.createElement(Flex, { flex: "1", alignItems: "center", justifyContent: "center" },
    React.createElement(Flex, { gap: "size-200", direction: "column", alignItems: "center" },
        React.createElement(ProgressCircle, { "aria-label": "Loading\u2026", isIndeterminate: true }),
        React.createElement(Text, { size: "XS" }, "Loading config"))));
export const MainView = () => {
    const config = useSelector((state) => state.editor.config);
    return (React.createElement(Flex, { UNSAFE_className: "annotely", flex: "1", width: "100%", height: "100%", maxHeight: "100%", direction: "column", UNSAFE_style: WrapperStyles },
        React.createElement(HeaderView, null),
        config ? React.createElement(ContentView, null) : React.createElement(LoadingConfigView, null),
        React.createElement(Prompt, null),
        React.createElement(BusyDialog, null),
        React.createElement(RejectionsDialog, null),
        React.createElement(NewsDialog, null),
        React.createElement(ClipboardDialog, null)));
};
